import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const PolitiqueConfidentialite = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Politique de Confidentialite</h1>
        <p>Protection de vos donnees personnelles - Conforme RGPD</p>
      </div>

      <div className="legal-content">
        <Link to="/" className="legal-back-link">
          ← Retour a l'accueil
        </Link>

        <div className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            La societe STREET DRIVE MARKET, exploitant le site f12ia.com sous la marque F12IA,
            s'engage a proteger la vie privee de ses utilisateurs conformement au Reglement
            General sur la Protection des Donnees (RGPD - Reglement UE 2016/679) et a la loi
            Informatique et Libertes du 6 janvier 1978 modifiee.
          </p>
          <p>
            Cette politique de confidentialite vous informe sur la maniere dont nous collectons,
            utilisons, stockons et protegeons vos donnees personnelles.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Responsable du traitement</h2>
          <div className="legal-info-box">
            <p><strong>Raison sociale :</strong> STREET DRIVE MARKET</p>
            <p><strong>Nom commercial :</strong> F12IA</p>
            <p><strong>Forme juridique :</strong> SAS au capital de 1 000,00 EUR</p>
            <p><strong>Siege social :</strong> 2 Allee des Pins, 30000 Nimes, France</p>
            <p><strong>SIRET :</strong> 914 635 495 00023</p>
            <p><strong>Email (DPO) :</strong> contact@f12ia.com</p>
          </div>
          <p>
            Pour toute question relative a vos donnees personnelles, vous pouvez nous contacter
            a l'adresse ci-dessus en indiquant "Protection des donnees" en objet.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Donnees collectees</h2>
          <p>
            Nous collectons uniquement les donnees strictement necessaires a la fourniture de nos services :
          </p>

          <h3>3.1 Donnees fournies directement par l'utilisateur</h3>
          <ul>
            <li><strong>Donnees d'identification :</strong> nom, prenom, adresse email</li>
            <li><strong>Donnees de facturation :</strong> adresse postale (si necessaire)</li>
            <li><strong>Identifiants de connexion :</strong> email, mot de passe (hashe)</li>
          </ul>

          <h3>3.2 Donnees collectees automatiquement</h3>
          <ul>
            <li><strong>Donnees de connexion :</strong> adresse IP, date et heure de connexion</li>
            <li><strong>Donnees de navigation :</strong> pages visitees, duree de visite</li>
            <li><strong>Donnees techniques :</strong> type de navigateur, systeme d'exploitation, resolution d'ecran</li>
            <li><strong>Progression pedagogique :</strong> modules completes, quiz effectues, certificats obtenus</li>
          </ul>

          <h3>3.3 Donnees de paiement</h3>
          <p>
            <strong>Important :</strong> Les donnees bancaires (numero de carte, date d'expiration, CVV)
            sont traitees exclusivement par notre prestataire de paiement Stripe. F12IA n'a jamais
            acces a ces donnees et ne les stocke pas. Stripe est certifie PCI-DSS niveau 1.
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Finalites et bases legales du traitement</h2>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Finalite</th>
                <th>Base legale</th>
                <th>Duree de conservation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gestion du compte utilisateur</td>
                <td>Execution du contrat</td>
                <td>Duree du compte + 3 ans</td>
              </tr>
              <tr>
                <td>Acces a la formation</td>
                <td>Execution du contrat</td>
                <td>Duree de l'acces</td>
              </tr>
              <tr>
                <td>Facturation et comptabilite</td>
                <td>Obligation legale</td>
                <td>10 ans</td>
              </tr>
              <tr>
                <td>Emails transactionnels</td>
                <td>Execution du contrat</td>
                <td>Duree du compte</td>
              </tr>
              <tr>
                <td>Amelioration des services</td>
                <td>Interet legitime</td>
                <td>2 ans (anonymise)</td>
              </tr>
              <tr>
                <td>Prevention de la fraude</td>
                <td>Interet legitime</td>
                <td>5 ans</td>
              </tr>
              <tr>
                <td>Newsletter marketing</td>
                <td>Consentement</td>
                <td>Jusqu'au retrait</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="legal-section">
          <h2>5. Destinataires des donnees</h2>
          <p>
            Vos donnees peuvent etre transmises aux destinataires suivants, dans le strict
            respect du RGPD :
          </p>
          <ul>
            <li>
              <strong>Stripe (paiements) :</strong> Traitement des paiements par carte bancaire.
              Stripe Inc., certifie PCI-DSS, dont le siege est aux USA (clauses contractuelles types).
            </li>
            <li>
              <strong>Firebase/Google Cloud (hebergement) :</strong> Stockage securise des donnees.
              Google LLC, certifie ISO 27001, hebergement en Europe (region eu-west).
            </li>
            <li>
              <strong>Vercel (hebergement frontend) :</strong> Hebergement du site web.
              Vercel Inc., USA (clauses contractuelles types).
            </li>
            <li>
              <strong>Service email (transactionnel) :</strong> Envoi des confirmations et notifications.
            </li>
          </ul>
          <p>
            <strong>Nous ne vendons, ne louons et ne partageons jamais vos donnees personnelles
            a des fins commerciales ou publicitaires.</strong>
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Transferts hors Union Europeenne</h2>
          <p>
            Certains de nos prestataires sont situes aux Etats-Unis. Dans ce cas, le transfert
            de donnees est encadre par :
          </p>
          <ul>
            <li>Les Clauses Contractuelles Types (CCT) approuvees par la Commission Europeenne</li>
            <li>Le Data Privacy Framework UE-USA pour les entreprises certifiees</li>
            <li>Des garanties supplementaires (chiffrement, pseudonymisation)</li>
          </ul>
          <p>
            Vous pouvez obtenir une copie des garanties mises en place en nous contactant.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Securite des donnees</h2>
          <p>
            F12IA met en oeuvre des mesures techniques et organisationnelles appropriees pour
            assurer la securite de vos donnees :
          </p>
          <ul>
            <li><strong>Chiffrement :</strong> Communications SSL/TLS (HTTPS), donnees chiffrees au repos</li>
            <li><strong>Authentification :</strong> Mots de passe hashes (bcrypt), tokens securises</li>
            <li><strong>Acces restreint :</strong> Principe du moindre privilege, logs d'acces</li>
            <li><strong>Sauvegardes :</strong> Sauvegardes automatiques chiffrees</li>
            <li><strong>Monitoring :</strong> Detection des anomalies et tentatives d'intrusion</li>
            <li><strong>Mise a jour :</strong> Application reguliere des correctifs de securite</li>
          </ul>
          <p>
            En cas de violation de donnees presentant un risque pour vos droits, vous serez
            informe dans les 72 heures conformement a l'article 34 du RGPD.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Vos droits (articles 15 a 22 du RGPD)</h2>
          <p>
            Conformement au RGPD, vous disposez des droits suivants sur vos donnees personnelles :
          </p>
          <ul>
            <li>
              <strong>Droit d'acces (art. 15) :</strong> Obtenir une copie de vos donnees et des
              informations sur leur traitement
            </li>
            <li>
              <strong>Droit de rectification (art. 16) :</strong> Corriger des donnees inexactes
              ou incompletes
            </li>
            <li>
              <strong>Droit a l'effacement (art. 17) :</strong> Demander la suppression de vos
              donnees ("droit a l'oubli"), sauf obligation legale de conservation
            </li>
            <li>
              <strong>Droit a la limitation (art. 18) :</strong> Limiter temporairement le
              traitement de vos donnees
            </li>
            <li>
              <strong>Droit a la portabilite (art. 20) :</strong> Recevoir vos donnees dans un
              format structure et lisible par machine
            </li>
            <li>
              <strong>Droit d'opposition (art. 21) :</strong> Vous opposer au traitement fonde
              sur l'interet legitime ou a des fins de prospection
            </li>
            <li>
              <strong>Droit de retirer votre consentement :</strong> A tout moment, sans affecter
              la liceite du traitement effectue avant le retrait
            </li>
            <li>
              <strong>Droit de definir des directives post-mortem :</strong> Concernant la
              conservation, l'effacement ou la communication de vos donnees apres votre deces
            </li>
          </ul>

          <div className="legal-info-box">
            <p><strong>Pour exercer vos droits :</strong></p>
            <p>Email : contact@f12ia.com</p>
            <p>Objet : "Demande d'exercice de droits RGPD"</p>
            <p>Joindre : Copie d'une piece d'identite</p>
            <p>Delai de reponse : 1 mois maximum (prolongeable de 2 mois si complexe)</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>9. Cookies et traceurs</h2>

          <h3>9.1 Qu'est-ce qu'un cookie ?</h3>
          <p>
            Un cookie est un petit fichier texte depose sur votre appareil lors de la visite
            d'un site web. Il permet de stocker des informations relatives a votre navigation.
          </p>

          <h3>9.2 Types de cookies utilises</h3>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Finalite</th>
                <th>Duree</th>
                <th>Consentement</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Cookies essentiels</td>
                <td>Authentification, securite, session</td>
                <td>Session / 30 jours</td>
                <td>Non requis (strictement necessaires)</td>
              </tr>
              <tr>
                <td>Cookies fonctionnels</td>
                <td>Preferences utilisateur</td>
                <td>1 an</td>
                <td>Oui</td>
              </tr>
              <tr>
                <td>Cookies analytiques</td>
                <td>Mesure d'audience, amelioration</td>
                <td>13 mois max</td>
                <td>Oui</td>
              </tr>
            </tbody>
          </table>

          <h3>9.3 Gestion des cookies</h3>
          <p>
            Vous pouvez a tout moment modifier vos preferences en matiere de cookies :
          </p>
          <ul>
            <li>Via les parametres de votre navigateur</li>
            <li>Via notre bandeau de consentement (accessible en bas de page)</li>
          </ul>
          <p>
            <strong>Note :</strong> Le refus des cookies essentiels peut empecher le fonctionnement
            du site et l'acces a votre compte.
          </p>
        </div>

        <div className="legal-section">
          <h2>10. Mineurs</h2>
          <p>
            Le site F12IA s'adresse a un public majeur. Nous ne collectons pas sciemment de
            donnees personnelles concernant des mineurs de moins de 16 ans.
          </p>
          <p>
            Si nous apprenons que des donnees d'un mineur ont ete collectees sans le
            consentement parental requis, nous les supprimerons immediatement.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Modification de la politique</h2>
          <p>
            F12IA se reserve le droit de modifier la presente politique de confidentialite
            a tout moment pour l'adapter aux evolutions legales et reglementaires.
          </p>
          <p>
            En cas de modification substantielle, vous serez informe par email et/ou par
            notification sur le site au moins 30 jours avant l'entree en vigueur des
            modifications.
          </p>
          <p>
            La date de derniere mise a jour est indiquee en bas de cette page.
          </p>
        </div>

        <div className="legal-section">
          <h2>12. Reclamation aupres de la CNIL</h2>
          <p>
            Si vous estimez que le traitement de vos donnees personnelles ne respecte pas la
            reglementation, vous avez le droit d'introduire une reclamation aupres de la
            Commission Nationale de l'Informatique et des Libertes (CNIL) :
          </p>
          <div className="legal-info-box">
            <p><strong>CNIL - Commission Nationale de l'Informatique et des Libertes</strong></p>
            <p>3 Place de Fontenoy - TSA 80715</p>
            <p>75334 Paris Cedex 07</p>
            <p>Telephone : 01 53 73 22 22</p>
            <p>Site web : www.cnil.fr</p>
          </div>
          <p>
            Nous vous invitons neanmoins a nous contacter en premier lieu pour tenter de
            resoudre votre probleme a l'amiable.
          </p>
        </div>

        <div className="legal-section">
          <h2>13. Contact</h2>
          <p>
            Pour toute question relative a cette politique de confidentialite ou au traitement
            de vos donnees personnelles :
          </p>
          <div className="legal-info-box">
            <p><strong>STREET DRIVE MARKET / F12IA</strong></p>
            <p>2 Allee des Pins</p>
            <p>30000 Nimes, France</p>
            <p>Email : contact@f12ia.com</p>
            <p>Objet : Protection des donnees personnelles</p>
          </div>
        </div>

        <p className="legal-update-date">
          Derniere mise a jour : Janvier 2025
        </p>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
